import { useMobileScreen } from '../../../shared-hooks/useMobileScreen'

type DayProps = {
  isActive: boolean
  hasSessions: boolean
  onClick: React.MouseEventHandler<HTMLButtonElement>
  date: Date
  disabled: boolean
}

export const Day = (props: DayProps): JSX.Element => {
  const isMobileScreen = useMobileScreen()

  if (isMobileScreen) {
    return <MobileDay {...props} />
  } else {
    return <DesktopDay {...props} />
  }
}

const DesktopDay = ({
  isActive,
  hasSessions,
  onClick,
  date,
  disabled,
}: DayProps): JSX.Element => (
  <button
    className={`relative rounded-full h-16 w-16 border-2 border-brand-light-purple bg-brand-light-purple ${
      isActive || hasSessions
        ? 'text-white'
        : 'text-brand-light-purple bg-opacity-0 hover:bg-opacity-25'
    }`}
    type='button'
    onClick={onClick}
    disabled={disabled}
  >
    <p className='text-sm font-light'>
      {date.toLocaleString('default', { weekday: 'short' })}
    </p>
    <p className='text-sm font-light'>
      {date.toLocaleString('default', { day: 'numeric' })}
    </p>
    {isActive && <p className='absolute font-bold -mt-4 left-7'>.</p>}
  </button>
)

const MobileDay = ({
  isActive,
  hasSessions,
  onClick,
  date,
  disabled,
}: DayProps): JSX.Element => (
  <button
    className={`rounded-xl w-9 py-1.5${
      isActive || hasSessions ? ' bg-brand-light-purple bg-opacity-50' : ''
    }${isActive ? ' -mt-3' : ''}`}
    type='button'
    onClick={onClick}
    disabled={disabled}
  >
    <p className='text-xs font-light text-[#686868] mb-2'>
      {date.toLocaleString('default', { weekday: 'narrow' })}
    </p>
    <p className='text-sm text-body-black font-medium'>
      {date.toLocaleString('default', { day: 'numeric' })}
    </p>
  </button>
)
